import styled, { css } from 'styled-components';

export interface Props {
	height?: number;
}

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Title = styled.h3`
	color: #000;
	font-size: 24px;
	font-weight: 700;
	line-height: normal;
	margin-bottom: 10px;
`;

export const List = styled.div<Pick<Props, 'height'>>`
	display: flex;
	flex-direction: column;
	gap: 10px;
	overflow: hidden;
	max-height: ${props => props.height}px;
	transition: max-height 0.3s ease-out;
`;

export const Button = styled.button`
	color: #339;
	font-size: 16px;
	font-weight: 700;
	line-height: 20px;
	margin-top: 10px;
	align-self: flex-end;
	width: max-content;
`;
